import React from "react";
import { css } from "styled-components";
import AnchorLink from "react-anchor-link-smooth-scroll";

import theme from "../../styles/theme";
import Link from "../util/link";
import GAEvent from "../util/GAEvent";

import BasicArrow from "@images/icons/basic-arrow.svg";

const { colors, button, font } = theme;

const styles = css`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-family: ${font.bold};
	text-align: center;
	font-size: 16px;
	padding: ${(props) => (props.secondary ? "0px" : "15px 20px")};
	border-radius: ${(props) => (props.secondary ? 0 : "30px")};
	min-width: 150px;
	width: fit-content;
	cursor: pointer;

	${(props) =>
		props.secondary
			? `		
	min-width: fit-content;
    background: linear-gradient(${colors.brandMain}, ${colors.brandMain});
    background-size: 0 2px;
    background-position: 0 80%;
    background-repeat: no-repeat;
    transition: background-size 0.75s ease-in-out, color .5s ease-in;
    color: ${colors.newBrand.black};

    :hover {
      background-size: 100% 2px;
      color: ${colors.brandMain};

    }
  `
			: `
    background: ${colors.brandMain};	
    transition: background 0.25s ease-in;
    color: ${colors.white};

    img {
      margin-left: 10px;
      transition: margin-left 0.25s ease-in;

    }

    :hover {
      background: ${colors.newBrand.brandDark};
      color: ${colors.white};

      img {
        margin-left: 20px;
      }
    }
  `};
`;

const ButtonContents = ({ gaEvent, children }) => {
	return gaEvent ? <GAEvent {...gaEvent}>{children}</GAEvent> : children;
};

export default ({ type, arrow, secondary, anchorLink, offset, onClick, gaEvent, ...props }) => {
	const buttonProps = {
		className: (type === "secondary" || secondary) && 'button--secondary',
		secondary: type === "secondary" || secondary,
		role: "button",
		...props,
	};

	if (props.link) {
		return (
			<Link to={props.disabled ? null : props.link} {...buttonProps} css={styles}>
				<ButtonContents gaEvent={gaEvent}>{props.children}</ButtonContents>
				{arrow && <img src={BasicArrow} alt="->" />}
			</Link>
		);
	}
	// eslint-disable-next-line no-else-return
	else if (anchorLink) {
		return (
			<AnchorLink offset={offset || "85"} href={anchorLink}>
				<div onClick={onClick} {...buttonProps} css={styles}>
					<ButtonContents gaEvent={gaEvent}>{props.children}</ButtonContents>
					{arrow && <img src={BasicArrow} alt="->" />}
				</div>
			</AnchorLink>
		);
	} else if (onClick) {
		return (
			<div onClick={props.disabled ? null : onClick} {...buttonProps} css={styles}>
				<ButtonContents gaEvent={gaEvent}>{props.children}</ButtonContents>
				{arrow && <img src={BasicArrow} alt="->" />}
			</div>
		);
	}

	return (
		<p>{`You must specify either a link or onClick to use <ButtonComponent> component correctly`}</p>
	);
};
